import { FC, useState } from 'react';

import { DateRangeChange } from 'ui/datePicker/types';

import { EventFilterContext, EventFilterState } from './filter';

const initialDateRange = {
  startDate: null,
  endDate: null,
};

export const FilterContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [dateRange, setDateRange] = useState<DateRangeChange>(initialDateRange);
  const { startDate, endDate } = dateRange;

  const context: EventFilterState = {
    dateRange,
    setDateRange,
    isFiltering: Boolean(startDate) || Boolean(endDate),
  };

  return <EventFilterContext.Provider value={context}>{children}</EventFilterContext.Provider>;
};
